/** Restrict page pinch-zoom only in the installed app; leave browser tabs alone. */
export function installStandaloneGestureGuard(doc: Document, win: Window) {
  const displayMode = win.matchMedia("(display-mode: standalone)");
  const standalone = () => displayMode.matches || Boolean((win.navigator as Navigator & { standalone?: boolean }).standalone);
  const update = () => doc.documentElement.classList.toggle("support-standalone", standalone());
  const gesture = (event: Event) => {
    if (standalone() && event.cancelable) event.preventDefault();
  };
  const touch = (event: TouchEvent) => {
    // Never intercept single-finger scrolling, taps, or keyboard input.
    if (event.touches.length > 1) gesture(event);
  };
  update();
  displayMode.addEventListener("change", update);
  doc.addEventListener("gesturestart", gesture, { passive: false, capture: true });
  doc.addEventListener("gesturechange", gesture, { passive: false, capture: true });
  doc.addEventListener("touchmove", touch, { passive: false, capture: true });
  return () => {
    displayMode.removeEventListener("change", update);
    doc.removeEventListener("gesturestart", gesture, { capture: true });
    doc.removeEventListener("gesturechange", gesture, { capture: true });
    doc.removeEventListener("touchmove", touch, { capture: true });
    doc.documentElement.classList.remove("support-standalone");
  };
}
